import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Label,
  Badge
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import FlashDatePicker from "../../Components/Common/FlashDatePicker";
import { useDispatch, useSelector } from "react-redux";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { DISCOUNT } from "../../helpers/data_helper";
import DishwiseTable from "./DishwiseTable";
import DayWeedBreakdown from "./DayWeedBreakdown";
import DishLineChart from "./DishLineChart";


const ForcastNew = () => {
    document.title = "KPI Dashboard | " + process.env.REACT_APP_NAME;
    const [leftCustomDate, setLeftCustomDate] = useState([]); 
    const [refresh, setRefresh] = useState(false);    

    const handleRefresh = () => {
        // setRecalculate(!recalculate);
        setRefresh(!refresh);
    }

    const [mealPeriod, setMealPeriod] = useState(0);
    const [filtermealperiod, setFiltermealperiod] = useState([]);
    const [filterDateList, setFilterDateList] = useState([]);
    const [currency, setCurrency] = useState('$');
    const [selectedMealList, setSelectedMealList] = useState(["all"]);
    const [dishCategoriesList, setDishCategoriesList] = useState([]);
    const [selectedDishCategories, setSelectedDishCategories] = useState([]);
    const [dateRange, setDateRange] = useState("7");


    const changeMealPeriod = (value) => {
      setMealPeriod(value);
    };
    const {
      filterData,
      filterAjax,
      currentOutlet
    } = useSelector((state) => ({
      filterData: state.Dashboard.filterData,
      filterAjax: state.Dashboard.filterAjax,
      currentOutlet:state.UserOutletGroup.currentOutlet
    }));
  
    const [leftFilter, setLeftFilter] = useState(
      filterData.flash_date?.find((date) => date.default) || false
    );
  
    useEffect(() => {  
      if (filterData.mealperiod) {
        const mealListArr = [];
        filterData.mealperiod.map((item) => {
          mealListArr.push({
            value: item.sp_id,
            label: item.title
          });
        });
        setFiltermealperiod(mealListArr);
      }
     
      if (filterData.flash_date) {
        setLeftFilter((prev) =>
          prev || filterData.flash_date.find((date) => date.default)
        );
        setFilterDateList(filterData.flash_date);
      }
    }, [filterAjax, filterData]); 

    useEffect(() => { 
      setDishCategoriesList([
        {label: "Starters", value: "starters"},
        {label: "Mains", value: "mains"},
        {label: "Desserts", value: "desserts"},
        {label: "Drinks", value: "drinks"},
        {label: "Salads", value: "salads"},
      ]);
    }, []);  

    const handleDishCategoriesClick = (badge) => {
      const isSelected = selectedDishCategories.includes(badge);

      if (isSelected) {
        // If already selected, remove it
        const updatedBadges = selectedDishCategories.filter((value) => value !== badge);
        setSelectedDishCategories(updatedBadges);
      } else {
        // If not selected, only add if less than 4 are selected
        if (selectedDishCategories.length < 4) {
          const updatedBadges = [...selectedDishCategories, badge];
          setSelectedDishCategories(updatedBadges);
        } else {
          // Optional: Alert or ignore
          alert("You can select up to 4 categories only.");
        }
      }
    };



    let date = new Date();
    date.setDate(date.getDate() - 1);
  
    
  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Restaurant Dish Forecast" pageTitle="Dashboard" activeDate={leftFilter} customDate={leftCustomDate} handleRefresh={handleRefresh}   />                              
      
          <form className="mb-3">
            <Row>
                {/* Time Period Filter */}
                <Col className="mb-2 mb-lg-0 ps-0" sm={12} lg={2}>
                    <select
                      className="form-select"
                      value={dateRange}
                      id="date_range"
                      onChange={(event) => setDateRange(event.target.value)}
                    >
                      <option value="7">7 Days</option>
                      <option value="14">14 Days</option>
                      <option value="30">30 Days</option>
                    </select>
                </Col>
                {/* Metrics Filter */}
                <Col sm={12} lg={2}>
                  <select
                    className="form-select"
                    value={mealPeriod}
                    id="mealPeriod"
                    onChange={(event) => changeMealPeriod(event.target.value)}
                  >
                    <option value="0">All Meal</option>
                    {!filterAjax &&
                      filtermealperiod.length > 0 &&
                      filtermealperiod.map((item) => {
                        return (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        );
                      })}
                  </select>
                </Col>
                {/* <Col sm={12} lg={2}>
                  
                </Col> */}
                <Col sm={12} lg={5}>
                  <div className="d-flex flex-column ms-3">
                    <Label className="ms-1 mb-2 mt-1 fw-normal">
                      Select Categories (up to 4)
                    </Label>
                    
                    <div className="d-flex flex-wrap gap-2">
                      {dishCategoriesList.map((badge) => (
                        <Badge
                          key={badge.value}
                          color={selectedDishCategories.includes(badge.value) ? "info" : "light"}
                          onClick={() => handleDishCategoriesClick(badge.value)}
                          style={{
                            padding: "0.75em 0.95em",
                            cursor: "pointer",
                            backgroundColor: selectedDishCategories.includes(badge.value) ? "" : "#d3d3d3",
                            color: selectedDishCategories.includes(badge.value) ? "" : "#000",
                            border: selectedDishCategories.includes(badge.value)
                              ? "1px solid #299CDB"
                              : "1px solid #ccc",
                          }}
                          className="fs-6"
                        >
                          {badge.label}
                        </Badge>
                      ))}
                    </div>
                  </div>
                </Col>  

                <Col sm={12} lg={3}>
                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    <Button
                    className="btn btn-light btn-outline-dark"
                    key="dashboard"
                    >
                    <i className="ri-arrow-left-line" style={{verticalAlign:"middle"}}></i>
                    Back to Dashboard
                    </Button>
                        <br />
                    <Button
                    className="btn btn-light btn-outline-danger"
                    key="forcast"
                    >
                    Export Forcast
                    </Button>
                    </div>
                </Col>          
            </Row>
          </form>

          <Row>
            <Col>
                <DishwiseTable dateRange={dateRange} mealPeriod={mealPeriod} selectedDishCategories={selectedDishCategories}   />
            </Col>
            <Col>
              <DishLineChart />
            </Col>
            <Col>
                <DayWeedBreakdown />
            </Col>
            
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ForcastNew;
